import { ReactNode } from 'react';
import { Root, Portal, Overlay, Content, Close, DialogTitle } from '@radix-ui/react-dialog';
import closeIcon from '@/assets/icons/close.svg';
// The shared overlay class on purpose: Blade recognises it as "a dialog is open" and
// keeps the details panel from closing behind the popup.
import dialogStyles from '@/components/ui/Dialog/Dialog.module.scss';
import styles from './CompactDialog.module.css';

interface CompactDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  /** Actions row pinned to the bottom of the card. */
  footer?: ReactNode;
  /** Slightly roomier card, for forms with a long picker inside. */
  wide?: boolean;
  /** Tighter card, for a short confirmation. */
  narrow?: boolean;
}

/**
 * A small centered modal - the shared MainDialogLayout takes over almost the whole
 * screen, which is far more than these short user forms need.
 */
const CompactDialog = ({ open, onClose, title, children, footer, wide = false, narrow = false }: CompactDialogProps) => (
  <Root open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
    <Portal>
      <Overlay className={dialogStyles.overlay} />
      <Content
        className={`${styles.content} ${wide ? styles.contentWide : ''} ${narrow ? styles.contentNarrow : ''}`}
        aria-describedby={undefined}
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <div className={styles.header}>
          <DialogTitle className={styles.title}>{title}</DialogTitle>
          <Close className={styles.closeButton}>
            <img src={closeIcon} alt="" />
          </Close>
        </div>
        <div className={`${styles.body} custom-scrollbar`}>{children}</div>
        {footer && <div className={styles.footer}>{footer}</div>}
      </Content>
    </Portal>
  </Root>
);

export default CompactDialog;
